var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningHexaOIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 88,
    viewBox: "0 0 80 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75436e-05 30.1139V57.8454C-0.00416577 60.7046 0.739864 63.5143 2.15712 65.9914C3.57437 68.4686 5.61477 70.5256 8.07267 71.9552L31.9273 85.8209C34.3817 87.2485 37.1659 88 40 88C42.8341 88 45.6183 87.2485 48.0727 85.8209L71.9273 71.9552C74.3852 70.5256 76.4256 68.4686 77.8429 65.9914C79.2601 63.5143 80.0042 60.7046 80 57.8454V30.1139C79.9971 27.2617 79.2497 24.4603 77.8328 21.9909C76.4159 19.5216 74.3793 17.471 71.9273 16.0448L48.0727 2.17907C45.6183 0.751537 42.8341 0 40 0C37.1659 0 34.3817 0.751537 31.9273 2.17907L8.07267 16.2481C5.65006 17.6568 3.63231 19.6755 2.21715 22.1062C0.802002 24.5368 0.0379999 27.2962 1.75436e-05 30.1139Z",
    fill: "#FCE3C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46 57.75C46 54.3125 43.3 51.5 40 51.5C36.625 51.5 34 54.3125 34 57.75C34 61.2656 36.625 64 40 64C43.3 64 46 61.2656 46 57.75ZM34.675 26.0312L35.65 47.2813C35.725 48.2188 36.55 49 37.45 49H42.475C43.375 49 44.2 48.2188 44.275 47.2813L45.25 26.0312C45.325 24.9375 44.5 24 43.45 24H36.475C35.425 24 34.6 24.9375 34.675 26.0312Z",
    fill: "#F38A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningHexaOIcon);
export default __webpack_public_path__ + "static/media/warning-hexa-o-icon.4f9b17dd9a57e1a3f37042b9f36083d0.svg";
export { ForwardRef as ReactComponent };